<img [src]="'/assets/fb-logo.svg'" alt="logo" title="logo" class="h-16" />
